"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedPriceResponse = void 0;
const date_util_1 = require("../../utils/date.util");
const single_price_1 = require("../single-price");
exports.mockedPriceResponse = {
  id: 1,
  isBase: true,
  startAt: date_util_1.takeDaysFromNow(),
  endAt: date_util_1.addDaysToNow(),
  list: [single_price_1.mockedSinglePriceResponse]
};